firebird.controller('virtualAssistantModalCtrl', [
    '$rootScope',
    '$scope',
    'helperService',
    'localizationService',
    'brandingService',
    'logService',
    'supportLinkService',
    'attendeeService',
    'socketService',
    'meetingService',
    'analyticsWrapperService',
    function (
        $rootScope,
        $scope,
        helperService,
        localizationService,
        brandingService,
        logService,
        supportLinkService,
        attendeeService,
        socketService,
        meetingService,
        analyticsWrapperService
    ) {
        var self = this;

        const logger = logService.createLoggerWithSource('virtualAssistantModalCtrl');

        self.modalState = 'closed';
        self.shouldInitialize = true;

        self.internalLink = supportLinkService.getSupportLink('transcription');
        self.privacyPolicyLink = brandingService.getPrivacyPolicyLink();
        self.aiPolicyLink = brandingService.getAiPolicyLink();
        self.showEnglishVirtualAssistantText = localizationService.isEnLocale;

        $scope.$on('show-modal', onShowModal);
        $scope.$on('hide-modal', onHideModal);
        $scope.$on('settings-view-state-change', onSettingsViewStateChanged);
        $scope.$on('settings-modal-closed', onSettingsModalClosed);
        $scope.$on('startVaOnRecording-updated', onStartVaOnRecordingUpdated);
        $scope.$on('sendRecapToAll-updated', onSendRecapToAllUpdated);

        self.getSupportLinkUrl = getSupportLinkUrl;
        self.getPrivacyPolicyLink = getPrivacyPolicyLink;
        self.getAiPolicyLink = getAiPolicyLink;

        self.cancel = cancel;
        self.init = init;
        self.save = save;
        self.onShowModal = onShowModal;
        self.onHideModal = onHideModal;

        self.settings = {
            startVaOnRecording: false,
            sendRecapToAll: false
        };
        self.showStartVaOnRecordingSetting = showStartVaOnRecordingSetting;
        self.showSendRecapToAllSetting = showSendRecapToAllSetting;
        init();

        ////////////////////////

        function init() {
            if (helperService.getIsRedesign()) {
                //In redesign, this ctrl doesn't get initiated until it first opens,
                //So the normal event listener to detect open/close does not get triggered on first open...
                //So we call onShowModal here (the event listener will call it on subsequent open/close)
                logger.debug('virtualAssistantModalCtrl init');
                self.onShowModal('show-modal', 'virtualAssistantMessage');
            }
            self.settings.startVaOnRecording = meetingService.getStartVaOnRecording();
            self.settings.sendRecapToAll = meetingService.getSendRecapToAll();
        }

        function save() {
            saveOnRecordingStartVa();
            saveSendRecapToAll();
        }

        function cancel() {
            self.settings.startVaOnRecording = meetingService.getStartVaOnRecording();
            self.settings.sendRecapToAll = meetingService.getSendRecapToAll
                ? meetingService.getSendRecapToAll()
                : false;
            // Ensure sendRecapToAll is false if startVaOnRecording is false
            if (!self.settings.startVaOnRecording) {
                self.settings.sendRecapToAll = false;
            }
        }

        function getSupportLinkUrl() {
            return self.internalLink;
        }

        function onStartVaOnRecordingUpdated(e, newValue) {
            self.settings.startVaOnRecording = newValue;
            if (!newValue) {
                // Reset sendRecapToAll when startVaOnRecording is disabled
                self.settings.sendRecapToAll = false;
                // Broadcast the change to ensure UI and server are updated
                $rootScope.$broadcast('sendRecapToAll-updated', false);
                // Update the server
                socketService.send({
                    message: 'set-sendRecapToAll',
                    data: {
                        sendRecapToAll: false
                    }
                });
            }
        }

        $scope.$watch('virtualAssistant.settings.startVaOnRecording', function (newValue, oldValue) {
            if (newValue === false && oldValue === true) {
                self.settings.sendRecapToAll = false;
                $rootScope.$broadcast('sendRecapToAll-updated', false);
                socketService.send({
                    message: 'set-sendRecapToAll',
                    data: {
                        sendRecapToAll: false
                    }
                });
            }
        });

        function onSendRecapToAllUpdated(e, newValue) {
            self.settings.sendRecapToAll = newValue;
        }

        function getPrivacyPolicyLink() {
            return self.privacyPolicyLink;
        }

        function getAiPolicyLink() {
            return self.aiPolicyLink;
        }

        function onShowModal(e, modalName) {
            if (modalName === 'virtualAssistantMessage') {
                self.modalState = 'open';
                digest();
            }
        }

        function onHideModal(e, modalName) {
            logger.log('onHideModal ... ');

            if (modalName.indexOf('virtualAssistantModalCtrl') !== -1) {
                self.modalState = 'closed';
                digest();
            }
        }

        //this function determines if the host wants VA to start and stop automatically with the recording
        function saveOnRecordingStartVa() {
            if (!attendeeService.getIsHost()) {
                logger.log('VAStartOnRecording will not be updated for not a host');
                return;
            }

            const currentValue = self.settings.startVaOnRecording;
            const originalValue = meetingService.getStartVaOnRecording();

            if (currentValue !== originalValue) {
                if (currentValue) {
                    analyticsWrapperService.eventTrack('Meeting AI Recap Enabled', {
                        source: 'Virtual Assistant Modal'
                    });
                } else {
                    analyticsWrapperService.eventTrack('Meeting AI Recap Disabled', {
                        source: 'Virtual Assistant Modal'
                    });
                    // When disabling startVaOnRecording, reset sendRecapToAll
                    self.settings.sendRecapToAll = false;
                    $rootScope.$broadcast('sendRecapToAll-updated', false);
                    socketService.send({
                        message: 'set-sendRecapToAll',
                        data: {
                            sendRecapToAll: false
                        }
                    });
                }
            }

            logger.log('Sending new startVaOnRecording val to server:', currentValue);

            $rootScope.$broadcast('startVaOnRecording-updated', currentValue);

            socketService.send({
                message: 'set-startVaOnRecording',
                data: {
                    startVaOnRecording: currentValue
                }
            });
        }

        //this function determines if the host wants to send AI recap to all participants
        function saveSendRecapToAll() {
            if (!attendeeService.getIsHost()) {
                logger.log('SendRecapToAll will not be updated for not a host');
                return;
            }

            const currentValue = self.settings.sendRecapToAll;
            const originalValue = meetingService.getSendRecapToAll ? meetingService.getSendRecapToAll() : false;

            if (currentValue !== originalValue) {
                if (currentValue) {
                    analyticsWrapperService.eventTrack('Meeting AI Recap Send to All Enabled', {
                        source: 'Virtual Assistant Modal'
                    });
                } else {
                    analyticsWrapperService.eventTrack('Meeting AI Recap Send to All Disabled', {
                        source: 'Virtual Assistant Modal'
                    });
                }
            }

            logger.log('Sending new sendRecapToAll val to server:', currentValue);

            $rootScope.$broadcast('sendRecapToAll-updated', currentValue);

            socketService.send({
                message: 'set-sendRecapToAll',
                data: {
                    sendRecapToAll: currentValue
                }
            });
        }

        function showStartVaOnRecordingSetting() {
            return meetingService.getAmiTranscriptionAvailable() && attendeeService.getIsHost();
        }

        function showSendRecapToAllSetting() {
            return attendeeService.getIsHost() && meetingService.getSendRecapToAllAvailable();
        }

        function onSettingsViewStateChanged(e, data) {
            if (data) {
                var tabName = 'virtual-assistant';

                if (data.openedTab === tabName) {
                    logger.log('Virtual Assistant Tab opened');

                    if (self.shouldInitialize) {
                        self.shouldInitialize = false;
                        self.onShowModal('show-modal', 'virtualAssistantMessage');
                    }
                } else if (data.closedTab === tabName) {
                    logger.log('Virtual Assistant Tab closed');

                    self.onHideModal('hide-modal', 'virtualAssistantModalCtrl');
                }
            }
        }

        function onSettingsModalClosed(e, data) {
            if (data.applyChanges === true) {
                logger.log('INSIDE MODAL CLOSED FUNCTION');
                logger.log('Virtual Assistant Modal - applying changes');
                self.save();
            } else {
                logger.log('Virtual Assistant Modal - closing without applying changes');
                self.cancel();
            }

            self.shouldInitialize = true;
            self.modalState = 'closed';
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
